import _ from 'lodash'
import { fromJS, List, Map, isImmutable } from 'immutable'
import * as actionTypes from './actionTypes'
import { disableHistory } from '../../constants/HISTORY_ENTRY_COUNT'

export const setBuilderActiveState = (status) => (dispatch, getState) => {
  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: disableHistory(getState()).setIn(['panels', 'smartform'], status),
    },
  })
}

export const handleSelectEmailSlide = (id) => (dispatch, getState) => {
  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: disableHistory(getState()).setIn(['slide'], id),
    },
  })
}
export const handleSelectModalStrip = (id) => (dispatch, getState) => {
  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: disableHistory(getState()).setIn(['modalStrip'], id),
    },
  })
}

export const processViewItemSelect = (uid, area, isAppend) => (dispatch, getState) => {
  const isFixed = getState().getIn(['widgets', 'selectionStatus'], false)
  if (!isFixed) {
    const state = disableHistory(getState())
    if (isAppend) {
      return dispatch({
        type: actionTypes.SET_STORE,
        payload: {
          store: state
            .setIn(['panels', 'elemenSettings', 'uid'], uid)
            .setIn(['selected'], fromJS(_.uniq([...state.getIn(['selected'], List()).toJS(), uid])))
            .setIn(
              ['selectedArea'],
              fromJS(area ? _.uniq([...state.getIn(['selectedArea'], List()).toJS(), area]) : [])
            ),
        },
      })
    } else {
      let pageID = state.hasIn(['project', 'Settings', 'elements', uid]) ? 'project' : state.get('page')
      let retState = state
        .setIn(['panels', 'elemenSettings', 'uid'], uid)
        .setIn(['selected'], fromJS([uid]))
        .setIn(['selectedArea'], fromJS(area ? [area] : []))

      retState = retState.setIn(['panels', 'elemenSettings', 'pageID'], fromJS(pageID))
      retState = retState.setIn(['panels', 'elementStyle', 'pageID'], fromJS(pageID))

      retState.getIn(['panels'], Map()).map((panel, key) => {
        if (isImmutable(panel)) {
          retState = retState.setIn(['panels', key, 'isActive'], false)
        }
      })

      if (!state.get('selected', List()).size) {
        if (retState.getIn(['panels', 'elemenSettings', 'pin'])) {
          retState = retState.setIn(['panels', 'elemenSettings', 'open'], true)
        }
        if (retState.getIn(['panels', 'elementStyle', 'pin'])) {
          retState = retState.setIn(['panels', 'elementStyle', 'open'], true)
        }
      }
      if (uid == 'Footer') {
        retState = retState.setIn(['panels', 'elementStyle', 'pageID'], 'project')
      }
      return dispatch({
        type: actionTypes.SET_STORE,
        payload: {
          store: retState,
        },
      })
    }
  }
}
